module.exports = __webpack_public_path__ + "static/media/arrow-up-green.582e7b92.svg";